import { AttachmentType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import SelectFilesSkeleton from './SelectFilesSkeleton';
import HandleOperation from 'components/utils/HandleOperation';
import { Box } from '@mui/material';
import RenderThumbnails from '@buildwise/pages/companyFiles/components/RenderThumbnails';
import { IMAGE_TYPES } from 'components/utils/constants';
import { useState } from 'react';
import LightboxModal from 'components/common/modal/LightboxModal';

type ExtractedImagesFromFileProps = {
  downloadedFiles: AttachmentType[];
  isDownloadingFiles: boolean;
};

function ExtractedImagesFromFile({
  downloadedFiles,
  isDownloadingFiles,
}: ExtractedImagesFromFileProps) {
  const [lightboxOpen, setLightboxOpen] = useState<{
    open: boolean;
    fileName: string;
  }>({
    open: false,
    fileName: '',
  });

  return (
    <Box my={1}>
      <HandleOperation
        isLoading={isDownloadingFiles}
        data={downloadedFiles}
        skelton={<SelectFilesSkeleton />}
        skeltonCount={1}
      >
        <RenderThumbnails
          // defaultGridMdSize={
          //   isFullScreen
          //     ? 4
          //     : articleType === ArticleSourceType.QUESTION ||
          //         articleType === ArticleSourceType.SUGGESTION
          //       ? 12
          //       : 6
          // }
          files={downloadedFiles}
          disabled
          // removeFile={onRemoveFile}
          setLightboxOpen={setLightboxOpen}
          // disabled={isSubmitting}
          // showEdit
          isImage={(file: AttachmentType) => {
            let fileType = `${file.fileType.toLowerCase().split('/')?.[1]}`;
            if (file.fileUploaded) {
              fileType = file.fileType.toLowerCase();
            }
            return IMAGE_TYPES.includes(
              file.fileUploaded ? `image/${fileType}` : file.fileType.toLowerCase(),
            );
          }}
        />
      </HandleOperation>

      {lightboxOpen.open && (
        <LightboxModal
          onClose={() => setLightboxOpen({ open: false, fileName: '' })}
          open={lightboxOpen.open}
          mode="view"
          mediaFiles={downloadedFiles}
          defaultOpenFileName={lightboxOpen.fileName}
        />
      )}
    </Box>
  );
}

export default ExtractedImagesFromFile;
